import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
// import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { adminMainUrl } from '../../../../Config';
const EditMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validationSchema = Yup.object({
        charge: Yup.string().required('Charge is required'),
        effectiveForm: Yup.string().required('Effective Form is required'),

        // name: Yup.string().required('Code is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            charge: "",
            effectiveForm: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });
    const ApplicableOption = []
    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Determination</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-12">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Determination <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value="Freight"
                                    disabled
                                />

                            </div>
                        </div>
                        <div className="col-12">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Charge <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="charge"
                                    name="charge"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.charge}
                                />
                                {formik.touched.charge && formik.errors.charge ? (
                                    <div className="error">{formik.errors.charge}</div>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Effective Form <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="effectiveForm"
                                    name="effectiveForm"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.effectiveForm}
                                />
                                {formik.touched.effectiveForm && formik.errors.effectiveForm ? (
                                    <div className="error">{formik.errors.effectiveForm}</div>
                                ) : null}
                            </div>

                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" >
                            Update
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster